var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "40px",
    viewBox: "0 0 31 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "appyhighF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7402816%",
    y1: "5.35588627%",
    x2: "68.9814261%",
    y2: "99.1467785%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA52DE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464DF1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "appyhighF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D852DF",
    x: 0,
    y: 0,
    width: 14.1312,
    height: 14.1312,
    rx: 2.65883
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D852DF",
    x: 0,
    y: 16.5435,
    width: 14.1312,
    height: 14.1312,
    rx: 2.65883
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D852DF",
    x: 16.5439,
    y: 0,
    width: 14.1312,
    height: 14.1312,
    rx: 2.65883
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1327,38.9645 C17.1327,39.741 17.9564,40.2404 18.6448,39.8813 L24.004,37.0871 C28.104,34.9491 30.6751,30.7088 30.6751,26.085 L30.6751,18.6114 C30.6751,17.4693 29.7492,16.5435 28.6071,16.5435 L18.6119,16.5435 C17.4698,16.5435 16.5439,17.4693 16.5439,18.6114 L16.5439,28.4268 C16.5439,29.5553 17.4587,30.4701 18.5872,30.4701 C20.3627,30.4701 21.2933,32.5787 20.0966,33.8904 L17.673,36.547 C17.3254,36.9278 17.1327,37.4252 17.1327,37.9408 L17.1327,38.9645 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconDark);
export default __webpack_public_path__ + "static/media/logo-icon-dark.2055bce9ccc03d0dcc1b844dc33c1647.svg";
export { ForwardRef as ReactComponent };